import { Component, computed, input, output } from '@angular/core';
import { DriverResponse } from 'src/app/models/driver.model';
import { NotificationProvider } from 'src/app/services/providers/notification-provider/notification-provider';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/services/core/core.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  standalone: false,
})
export class MainHeaderComponent {
  /* Indicates whether the application is running inside a mobile container */
  isMobileApp = input<boolean>(false);

  /* Represents the current authentication state of the user */
  isLoggedIn = input<boolean>(false);

  /* Logged-in driver details used for header display */
  driverData = input<DriverResponse | null>(null);

  /* Disables header actions during mandatory flows */
  disabled = input<boolean>(false);

  /* Emits logout intent to the parent container */
  logout = output<void>();

  /*  unread notification count for header badge */
  unreadCount = computed(() =>
    this.notificationProvider.readUnreadNotificationsCount()
  );

  constructor(
    private readonly notificationProvider: NotificationProvider,
    private readonly coreService: CoreService,
    readonly router: Router,
  ) { }

  /* Handles navigation to the notifications screen */
  goToNotification(): void {
    if (this.disabled()) {
      return;
    }

    this.router.navigate(['/notifications', '0', false]);
  }

  /* Handles navigation to header-linked routes */
  goToLink(route: string): void {
    if (this.disabled()) {
      return;
    }

    this.router.navigateByUrl("/" + route);
  }

  /* Triggers logout action */
  processLogout(): void {
    this.logout.emit();
  }

  get showNotification() {
    return this.coreService.isFeatureFlagExists('Notification');
  }
}
